




















import Debug from "@/components/utility/Debug.vue";
import LayoutReport from "@/layouts/LayoutReport.vue";
import TheLayoutBase from "@/layouts/TheLayoutBase.vue";
import { Component, Ref } from "vue-property-decorator";
import DocumentDetailCardEditor from "../sign/DocumentDetailCardEditor.vue";
import ImagePositionSelector from "../sign/ImagePositionSelector.vue";

@Component({
  components: {
    TheLayoutBase,
    LayoutReport,
    Debug,
    DocumentDetailCardEditor,
    ImagePositionSelector
  }
})
export default class SignFormEditorCanvas extends DocumentDetailCardEditor {
  @Ref("selector")
  selector!: ImagePositionSelector;
}
